import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { DisconnectKCloudRequestModel } from "@/features/accounts/account-group/services/disconnect-kcloud-model";

export class DisconnectKCloudApi {
  /**
   * サービス連携解除
   */
  public disconnectKCloud = async (
    param: DisconnectKCloudRequestModel
  ): Promise<void> => {
    const path = `/api/cloud_deletelink`;
    const res = await ApiClient.instance.delete({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }
  };
}
